/** @jsxImportSource theme-ui @jsxRuntime classic */
import {
  Box,
  Text,
  Flex,
  // ThemeUIComponentProps,
  Checkbox,
} from '@tishman/components';
import React, { Fragment, useEffect, useState } from 'react';

import type { ThemeUIStyleObject } from 'theme-ui';
export type AddButtonBorderRadiusVariant = 'big' | 'small';

interface QuantityTicketProps {
  count: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
  isSingleChecked?: boolean;
  isSingleDisabled?: boolean;
  isSingleTicket?: boolean;
  addButtonBorderRadiusVariant?: AddButtonBorderRadiusVariant;
  wrapperStyles?: {
    alignSelf?: string | string[];
    marginTop?: string | string[] | number | number[];
  };
}

export const QuantityPicker = ({
  addButtonBorderRadiusVariant = 'small',
  disabled = false,
  isSingleChecked = false,
  isSingleDisabled = false,
  isSingleTicket = false,
  count,
  onDecrement,
  onIncrement,
  wrapperStyles,
}: QuantityTicketProps) => {
  const commonButtonStyles: ThemeUIStyleObject = {
    'width': [40, 36],
    'height': [40, 36],
    'background': '#EAEAEA',
    'display': 'inline-block',
    'textAlign': 'center',
    'cursor': 'pointer',
    'lineHeight': ['40px', '34px'],
    'fontWeight': 'regular',
    'userSelect': 'none',
    'fontSize': 6,
    ':hover': {
      background: '#2F2F2F',
      color: '#FFFFFF',
    },
  };

  const disabledButtonStyles: ThemeUIStyleObject = {
    'color': '#A3A3A3',
    'backgroundColor': '#F3F3F3',
    'cursor': 'not-allowed',
    ':hover': {
      color: '#A3A3A3',
      backgroundColor: '#F3F3F3',
    },
  };

  const [checked, setChecked] = useState(isSingleChecked);

  useEffect(() => {
    setChecked(isSingleChecked);
  }, [isSingleChecked]);

  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: ['flex-end', 'center'],
        minWidth: 118,
        ...wrapperStyles,
      }}
    >
      {isSingleTicket ? (
        <Flex sx={{ justifyContent: 'center', alignSelf: 'center' }}>
          <Checkbox
            checked={checked}
            disabled={isSingleDisabled}
            onChange={(e) => {
              setChecked(e.target.checked);
              if (e.target.checked) {
                onIncrement();
              } else {
                onDecrement();
              }
            }}
            sx={{
              color: isSingleDisabled ? 'backgroundDisabled' : 'navy',
              cursor: isSingleDisabled ? 'not-allowed' : 'pointer',
            }}
            text=""
          />
        </Flex>
      ) : (
        <Fragment>
          <Box
            data-testid="decrement-button"
            onClick={() => count > 0 && onDecrement()}
            sx={{
              ...commonButtonStyles,
              borderRadius: 28,
              ...(count === 0 && disabledButtonStyles),
            }}
          >
            -
          </Box>
          <Text
            data-testid="quantity-picker-count"
            sx={{
              variant: 'text.mediumTitle',
              width: 30,
              textAlign: 'center',
              mx: 2,
              fontSize: 6,
            }}
          >
            {count}
          </Text>
          <Box
            data-testdisabled={disabled}
            data-testid={
              disabled ? 'disabled-increment-button' : 'increment-button'
            }
            onClick={() => !disabled && onIncrement()}
            sx={{
              ...commonButtonStyles,
              ...(disabled && disabledButtonStyles),
              borderRadius: addButtonBorderRadiusVariant === 'big' ? 50 : 28,
            }}
          >
            +
          </Box>
        </Fragment>
      )}
    </Flex>
  );
};
